// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4bfd025a","239":"8ae8cfee","455":"2dee7dc6","488":"f4393501"}[chunkId] + ".chunk.js";
};